module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../node_modules/coffee-loader/index.js!./zh-HANS.coffee"));
	}, "locale/zh-HANS");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=locale/[name]!./app/locale/zh-HANS.coffee
// module id = 308
// module chunks = 97